/// This function is uncallable in TypeScript, so the compiler will complain if it is called.
/// It can thus be used to make switches and checks exhaustive, by passing the checked value in here in the default case.
export function assertExhausted(unreachable: never) {}

export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

export enum ConsultationTypeEnum {
    None = 0,
    StartupVideoTanke = 1,
    FollowupVideoTanke = 2,
    StartupVideoPres = 3,
    FollowupVideoPres = 4,
}

export enum UserRoleEnum {
    Patient = 1,
    Doctor = 2,
    Admin = 3,
    Visitator = 4,
    CustomerService = 5,
}

export enum CaregiverRoleEnum {
    None = 0,
    Psychologist = 1,
}

export enum SignupDoctorResponseEnum {
    OK,
    Failed,
    EmailExists,
}

export enum OpenVideoConsultationStatusEnum {
    OK = 0,
    NoDoctorsAvailable = 1,
    TimeSlotOverbooked = 2,
}

export enum ServiceTypeEnum {
    VideoConsultation = 0,
    Message = 1,
    MessageReply = 2,
    Prescription = 3,
    DermatologistMessage = 4,
    DermatologistMessageReply = 5,
    RheumatologistVideo = 6,
    PhysiotherapistStartupVideo = 7,
    DermatologistVideo = 8,
    PsychologistVideo = 9,
    AllergyCheckVideo = 10,
    SundVaegtStartupMessage = 11,
    SundVaegtNurseCheckupVideo = 12,
    SundVaegtDoctorCheckupVideo = 13,
    SundVaegtNurseCheckupMessage = 14,
    SundVaegtNurseCheckupMessageReply = 15,
    SundVaegtNurseAdHocVideo = 16,
    SundVaegtQuestionnaireMessage = 17,
    PhysiotherapistMessage = 18,
    PhysiotherapistMessageReply = 19,
    PhysiotherapistCheckupVideo = 20,
    SundVaegtQuestionnaireMessageReply = 21,
    PhysiotherapistQuestionnaireMessage = 22,
    SundVaegtStartupMessageReply = 23,
    DietitianStartupVideo = 24,
    DietitianCheckupVideo = 25,
    PsychologistCrisisVideo = 26,
    PersonalHealthProgrammeStartup = 27,
}

export enum OrderStatusEnum {
    ProcessingInEpay = 1,
    ProcessingInLaegecheck = 2,
    Completed = 3,
    Canceled = 4,
}

export enum AvailableRelationTypeEnum {
    Child = 0,
    Partner = 1,
    Himself = 2,
}

export enum DeviceTypeEnum {
    Browser = 0,
    iOS = 1,
    Android = 2,
}

export enum PaymentProvider {
    Company = 0,
    AppStore = 1,
    GoogleWallet = 2,
    ePay = 3,
    DIBS = 4,
    Subscription = 5,
    ReepayCheckout = 7,
    GracePeriod = 8,
    PriceOverride = 9,
}

export enum InsurancePolicyProviderType {
    None = 0,
}

export enum PhoneCallRejectedReason {
    ConsultationIsAlreadyTaken = 'ConsultationIsAlreadyTaken',
}

export enum Program {
    Tanke = 0,
    Pres = 1,
}

export type TrialInfoStatus =
    | 'PaymentNeeded'
    | 'FillOutRequest'
    | 'AwaitingRequestProcessing';
